import moment from "moment/moment";
import WatsonApi from "../../backends/WatsonApi";
import { IFallbackData } from "../../utils/SchoolBlocksUtilities";

interface SchoolFeedItemListQuery {
  organization_id?: string;
  is_event: boolean;
  created_at__gte: string;
  created_at__lte: string;
  page_size: number;
  ordering: string;
  expand: string[];
  published?: boolean;
}

export const currentRangeUrlQueryFormat = "YYYY-MM-DD";

export const eventsQuery = (gte, lt, baseFilterParams?) => {
  return {
    is_event: true,
    created_at__gte: gte,
    created_at__lt: lt,
    page_size: 200,
    published: true,
    expand: ["organization"],
    ordering: "created_at",
    ...baseFilterParams,
  };
};

export const getEventsForRange = async (
  pathQueryParams,
  urlQuery,
  start?: string,
  end?: string,
): Promise<IFallbackData> => {
  let gte;
  let lte;

  if (start && end) {
    gte = start;
    lte = end;
  } else {
    gte = moment().startOf("month").format(currentRangeUrlQueryFormat);
    lte = moment()
      .add(1, "months")
      .startOf("month")
      .format(currentRangeUrlQueryFormat);
  }

  return new Promise((res) => {
    WatsonApi().then((client) => {
      const q: SchoolFeedItemListQuery = eventsQuery(gte, lte, pathQueryParams);

      let method;
      if (urlQuery.orgId) {
        method = client.apis.organizations.organizations_schoolfeed_items_list;
      } else {
        method = client.apis.schoolfeed_items.schoolfeed_items_list;
      }

      method({
        organization_pk: urlQuery.orgId,
        ...q,
      }).then((result) => {
        res({
          contentItems: result.obj.data,
          total: result.obj.meta.total,
        });
      });
    });
  });
};
